import { Injectable } from "@angular/core";

import { WebConstants } from "../util/web.constants";
import { Observable } from "rxjs";
import { BaseResponse } from "../model/base.response";
import { AjaxHelper } from "../helper/ajax.helper";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class EnforcementVehicleService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper) {}

  getAll(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(
      this.baseUrl + WebConstants.API_URL.ENFORCEMENT_VEHICLE.FIND_ALL
    );
  }

  addVehicle(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(
      this.baseUrl + WebConstants.API_URL.ENFORCEMENT_VEHICLE.ADD_VEHICLE,
      payload
    );
  }

  updateVehicle(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(
      this.baseUrl + WebConstants.API_URL.ENFORCEMENT_VEHICLE.UPDATE_VEHICLE,
      payload
    );
  }

  deleteVehicle(vehicleid: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(
      this.baseUrl +
        WebConstants.API_URL.ENFORCEMENT_VEHICLE.DELETE_VEHICLE +
        vehicleid
    );
  }
}
